import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SsoGroup } from "@data/security";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";

const API_URL = API.API_URL;

@Injectable({
  providedIn: "root"
})
export class SsoMappingService {
  ssoGroups: SsoGroup[] = [];
  private _SecurityAPIBase = `${API_URL}/security`;
  private _ssoBase = `${this._SecurityAPIBase}/sso`;
  constructor(private httpManager: HttpManager) {}

  public getSsoGroups(id: number = null): Observable<any> {
    if (id) {
      return this.httpManager.httpGet<any>(`${this._ssoBase}/${id}`, { id: id });
    }
    return this.httpManager.httpGet<any>(`${this._ssoBase}`);
  }

  public addSsoGroup(body: SsoGroup): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._ssoBase}/add`, body);
  }

  public updateSsoGroup(body: SsoGroup): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._ssoBase}/${body.value}/update`, body);
  }

  public deleteSsoGroup(id: number): Observable<any> {
    return this.httpManager.httpGet<any>(`${this._ssoBase}/${id}/delete`);
  }
}
